import { api } from './index';

const BASE_PATH = '/api/internal/patient_tasks';

export type TimeType = 'specific' | 'am' | 'pm';

export type PatientTask = {
  id: number;
  patientId: number;
  taskDefinitionId: number;
  scheduledTime: string;
  timeType: TimeType;
  humanScheduledTime: string;
  observations?: string;
  assignedById: number;
  assignedByEmail: string;
  taskDefinitionName: string;
  taskDefinitionDescription: string;
  taskCategoryName: string;
  discardedAt?: string;
  discarded: boolean;
  humanCreatedAt: string;
  humanDiscardedAt?: string;
};

export interface PatientTaskForm {
  taskDefinitionId: number;
  scheduledTime?: string;
  timeType: TimeType;
  observations?: string;
}

export const patientTasksApi = {
  index(patientId: number, scope: 'active' | 'discarded' = 'active'): Promise<Array<PatientTask>> {
    return api({
      method: 'get',
      url: BASE_PATH,
      params: {
        patient_id: patientId, // eslint-disable-line camelcase
        scope: scope === 'discarded' ? 'discarded' : undefined,
      },
    }).then(response => response.data.patientTasks);
  },
  create(patientId: number, patientTaskForm: PatientTaskForm): Promise<PatientTask> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { patient_id: patientId, patientTask: patientTaskForm }, // eslint-disable-line camelcase
    }).then(response => response.data.patientTask);
  },
  update(id: number, patientTaskForm: PatientTaskForm): Promise<PatientTask> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${id}`,
      data: { patientTask: patientTaskForm },
    }).then(response => response.data.patientTask);
  },
  undiscard(id: number): Promise<PatientTask> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${id}`,
      params: { undiscard: true },
    }).then(response => response.data.patientTask);
  },
  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${id}`,
    });
  },
};
